import dayjs from "dayjs";
dayjs.locale('es')

export const formatoHora =(fecha) =>{
    if (!fecha) {
        return ''
    }

    let fec = dayjs(fecha).format('HH:mm a')
    return fec.substring(0, 1).toUpperCase() + fec.substring(1, fecha.length)
}